import { App } from "@/utils/apps";
import { Admin } from "@/models/admin";
import { ISelectItem } from "winfakt-vue-components";

export enum RoadmapStatus {
	COMPLETED = 1,
	IN_BETA = 2,
	IN_PROGRESS = 3,
	PLANNING = 4,
	RESEARCH = 5
}

export function getAllRoadmapStatuses():RoadmapStatus[] {
	return [
		RoadmapStatus.COMPLETED,
		RoadmapStatus.IN_BETA,
		RoadmapStatus.IN_PROGRESS,
		RoadmapStatus.PLANNING,
		RoadmapStatus.RESEARCH,
	];
}

export function getAllRoadmapStatusesSelectItems():ISelectItem<RoadmapStatus>[]{
	return [
		{
			value: RoadmapStatus.COMPLETED,
			text: "Completed",
		},
		{
			value: RoadmapStatus.IN_BETA,
			text: "In beta",
		},
		{
			value: RoadmapStatus.IN_PROGRESS,
			text: "In progress",
		},
		{
			value: RoadmapStatus.PLANNING,
			text: "Planning",
		},
		{
			value: RoadmapStatus.RESEARCH,
			text: "Research",
		},
	];
}

export class RoadmapItem{
	id:number = 0;
	adminId:number = 0;
	appName:App = App.WINFAKT_MAIN_APP;
	title:string = "";
	intro:string = "";
	text:string = "";
	unformatedText:string = "";
	status:RoadmapStatus = RoadmapStatus.PLANNING;
	isCommingSoon:boolean = true;
	inDevelopment:boolean = true;
	date:Date | null = null;
	vimeoLink:string = "";
	priority:number = 1;
	admin?:Admin;


	public constructor(data?:any){
		if (!data) return;
		this.id = data.id;
		this.adminId = data.adminId;
		this.appName = data.appName;
		this.title = data.title;
		this.intro = data.intro;
		this.text = data.text;
		this.unformatedText = data.unformatedText;
		this.status = data.status;
		this.isCommingSoon = data.isCommingSoon;
		this.inDevelopment = data.inDevelopment;
		if (data.date){
			this.date = new Date(data.date);
		}
		this.vimeoLink = data.vimeoLink;
		this.priority = data.priority;
		if (data.admin) {
			this.admin = new Admin(data.admin);
		}
	}

	public getJSON(){
		return {
			id: this.id,
			adminId: this.adminId,
			appName: this.appName,
			title: this.title,
			text: this.text,
			intro: this.intro,
			unformatedText: this.unformatedText,
			status: this.status,
			isCommingSoon: this.isCommingSoon,
			inDevelopment: this.inDevelopment,
			date: this.date ? this.date.toJSON() : null,
			vimeoLink: this.vimeoLink,
			priority: this.priority
		};
	}

}